import { useQuery } from '@tanstack/react-query';
import {
  StatusCode,
  getCustomerOrders,
  type GetCustomerOrdersParams as Params,
} from '@hungryroot/rest';
import { GET_CUSTOMER_ORDERS_QUERY_KEY } from './getOrderQueryKeys';

const timeLimit = 5 * 60 * 1000;

export function useGetOrders(
  params: Params,
  options?: {
    staleTime?: number;
    enabled?: boolean;
  }
) {
  return useQuery({
    queryKey: [...GET_CUSTOMER_ORDERS_QUERY_KEY, params],
    queryFn: async () => {
      const resp = await getCustomerOrders(params);

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    enabled: options?.enabled !== false,
    gcTime: timeLimit,
    staleTime: options?.staleTime || timeLimit,
  });
}
